const OTHERS_CATEGORY = 'others';
const otherTariffNumberOption = {
  tariff_number: OTHERS_CATEGORY,
  description: 'customs-form.category.others'
};

export { OTHERS_CATEGORY, otherTariffNumberOption };
//# sourceMappingURL=CustomsInvoiceItemTypes.js.map
